// extracted by mini-css-extract-plugin
export default {"checkboxInput":"Checkbox_checkboxInput__NE5pW","baseCheckbox":"Checkbox_baseCheckbox__u7fVq","isDisable":"Checkbox_isDisable__NTrJn"};